import {Component, Inject, OnInit} from '@angular/core';
import {FormArray, FormControl, FormGroup, Validators} from "@angular/forms";
import {Observable, Subject, takeUntil} from "rxjs";
import {Centre} from "../../../../interfaces/Centres";
import {FullChild} from "../../../../interfaces/FullChild";
import {Employee} from "../../../../interfaces/Employee";
import {CentreService} from "../../../../services/centre.service";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MatSnackBar} from "@angular/material/snack-bar";
import {CounselingService} from "../../counseling.service";
import {EmployeeService} from "../../../../services/employee.service";
import {Router} from "@angular/router";
import {LocationStrategy} from "@angular/common";
import {ChildService} from "../../../../components/child/child.service";
import {MatSelectChange} from "@angular/material/select";
import firebase from "firebase/compat";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import Timestamp = firebase.firestore.Timestamp;
import {LogService} from "../../../../services/log.service";
import {GlossaryService} from "../../../../components/glossary/glossary.service";

@Component({
  selector: 'app-edit-assessment-counseling',
  templateUrl: './edit-assessment-counseling.component.html',
  styleUrls: ['./edit-assessment-counseling.component.scss']
})
export class EditAssessmentCounselingComponent implements OnInit {
  form: FormGroup<any>
  answers = ['Yes', 'No', 'Sometimes']
  centreList$: Observable<Centre[]>;
  child$?: Observable<FullChild[]>;
  questionSet: string[] = []
  emp$: Observable<Employee[]>
  types = ["Admission Baseline Assessment", "Intermediate Assessment", "Discharge Assessment"]
  mGlossaryData:any
  destroyed$ = new Subject()

  constructor(private readonly centerService: CentreService,
              private readonly mFirestore: AngularFirestore,
              private _snackbar: MatSnackBar,
              private readonly mLogService:LogService,

              private counsellingService: CounselingService,
              private empService: EmployeeService,
              private router:Router,
              private location: LocationStrategy,
              private  readonly mGlossary: GlossaryService,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private readonly childService: ChildService) {
    this.form = new FormGroup({
      //selectCentre: new FormControl('',),
      type: new FormControl(this.data.type, Validators.required),
      centreName: new FormControl(this.data.centreName, Validators.required),
      // selectChild: new FormControl('', Validators.required),
      childCode: new FormControl(this.data.childCode, Validators.required),
      childName: new FormControl(this.data.childName, Validators.required),
      unitCode: new FormControl(this.data.unitCode),
      parentsName: new FormControl(this.data.parentsName, Validators.required),
      city: new FormControl(this.data.city, Validators.required),
      dateOfAdmission: new FormControl((this.data.dateOfAdmission as Timestamp).toDate(), Validators.required),
      personConductingTest: new FormControl(this.data.personConductingTest, Validators.required),
      designation: new FormControl(this.data.designation, Validators.required),
      dateOfAssessment: new FormControl((this.data.dateOfAssessment as Timestamp).toDate(), Validators.required),
      assessment: new FormArray([], ),
      // createdAt:new FormControl(Date.now())
    })
    this.form.get('personConductingTest')?.disable()

    this.centreList$ = centerService.getAllCentres()
    // this.empService.getEmployee()
    this.emp$ = this.empService.getCounsellers()
    this.setQuestionsFromData()

  }

  ngOnInit(): void {
    // this.setQuestions()
    this.mGlossary.fetchCounsellingGlossary().pipe(takeUntil(this.destroyed$)).subscribe(res=>{

      this.mGlossaryData  =res
    })
  }

  private addQuestion(s: string) {
    let array = this.form.get('assessment') as FormArray
    array.push(this.assessmentModel(s))
  }
  private addQuestionData(s: string,ans:string) {
    let array = this.form.get('assessment') as FormArray
    array.push(this.assessmentModelData(s,ans))
  }
  assessmentModel(q: string) {
    return new FormGroup({
      q: new FormControl(q),
      ans: new FormControl(null, Validators.required)
    })
  }
  assessmentModelData(q: string,ans:string) {
    return new FormGroup({
      q: new FormControl(q),
      ans: new FormControl(ans, Validators.required)
    })
  }
  onCentreSelect($event: MatSelectChange) {
    let centre = $event.value as Centre
    console.log($event.value)
    this.form.get('centreName')?.setValue(centre.centreName)
    this.form.get('centreCode')?.setValue(centre.centreCode)
    this.child$ = this.childService.getAllotedChildListByCenter($event.value.centreCode)
  }

  childSelect($event: MatSelectChange) {
    let child = $event.value as FullChild
    console.log($event.value)
    this.form.get('parentsName')?.setValue(`${child.guardians[0].firstName} and ${child.guardians[1].firstName}`)
    console.log(this.form.get('parentsName')?.value)
    this.form.get('childName')?.setValue(`${child.firstName} ${child?.lastName}`)
    this.form.get('childCode')?.setValue(`${child.childCode}`)
    console.log(this.form.get('childName')?.value)
    this.form.get('city')?.setValue(child?.city)
    this.form.get('city')?.disable()
    this.form.get('unitCode')?.setValue(child?.selectUnit)
    this.form.get('dateOfAdmission')?.setValue((child.dateOfAdmission as unknown as Timestamp).toDate())
    this.form.get('dateOfAdmission')?.disable()
    this.form.get('parentsName')?.disable()
  }

  get assessments() {
    return this.form.get('assessment') as FormArray
  }

  Submit() {

    // this.counsellingService.addAssessment(this.form.value).then(()=>{
    //     alert('Assessment Updated')
    // })

    if (this.form.valid) {
      console.log('Form is valid')
      this.form.addControl('createdAt', new FormControl(Date.now()))
      this.counsellingService.editAssessment(this.form.getRawValue(),this.data.id).then(() => {
        let activity={
          date:new Date().getTime(),
          section: 'Assessment Counseling',
          action: 'Update',

          description: `Assessment for ${ this.form.get('childCode')?.value}  ${ this.form.get('childName')?.value} Update to Counseling by  `,
          currentIp: localStorage.getItem('currentip')!
        }
        this.mLogService.addLog(activity)
        alert('Assessment Updated')
        this.location.back()
      })
      // this.mFirestore.collection('counsellingTest').add(this.form.value).then(() => {
      // this._snackbar.open('Assessment sent successfully', 'SUCCESS')._dismissAfter(3000)
      // })
    } else {
      console.log('invalid form')
    }
    console.log(this.form.value)
    console.log('INVALID CONTROLS', this.findInvalidControls())
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  setQuestions() {
    let q1 = '1.Are you experiencing sleeplessness after understanding about your child’s illness and gravity of the situation?'
    let q2 = "2.Are you experiencing loss of appetite after knowing that your child has this illness and the treatment that he/she is undergoing?"
    let q3 = "3.Are you feeling dizziness/ giddiness/ nausea while performing daily routine activities, due to the thought process involving your child’s illness?"
    let q4 = "4.Are you experiencing headache/mental stress due to the thoughts about your child’s illness and the treatment which is underway?"
    let q5 = "5.Are you unable to relax/ take proper rest due to the constant thoughts of your child having this illness and the treatment undergoing?"
    let q6 = "6.Are you feeling tiredness/ loss of energy/ no strength to perform normal routine task, due to your child’s illness?"
    let q7 = "7.Are you experiencing helplessness and unable to cope with the current situation due to the fact that your child has this illness?"
    let q8 = "8.Are you having this thought about death/ dying/ sadness cause of the present circumstances involving your child’s illness?"
    let q9 = "9.Do you keep thinking that something really bad or worse is going to happen to me and my family, in relation to the illness and treatment of your child?"
    let q10 = "10.Do you feel angry/ agitated cause of the circumstances you are involved in at present primarily concerning the health of your child?"
    let q11 = "11.Are you undergoing stages of nervousness due to the fact that your child’s treatment is underway and there is always this constant fear of the outcome? "
    let q12 = "12.Is it difficult to figure out and understand the changing behavior of your child when he/ she is undergoing the cancer treatment?"
    let q13 = "13.Is it difficult to identify and handle the changing food related habits of the Child?"
    let q14 = "14.Is it difficult to understand and handle the stubbornness of the child?   "
    let q15 = "15.Is it difficult to understand and handle the mood swings of your child during this ongoing treatment?               "
    let q16 = "16.Is it difficult to handle the aggression and violent behavior of your child?"
    let q17 = "17.Did you face any problems in adjusting to the Access Life Centre?"
    let q18 = "18.Do you face awkwardness in asking for help?"
    let q19 = "19.Do you find it difficulty in adjusting to the rules, regulations and schedules of the Access Life?"
    let q20 = "20.Do you face any miscommunication with others due to the language barrier?"
    let q21 = "21.Do you find it difficult to freely speak and seek support from the counsellor? "
    let q22 = "22.Do you get thoughts of abandoning/giving up your child’s treatment?"
    let q23 = "23.Do you get exhausted with the amount of time you have to give for taking care of your child when undergoing this treatment?"
    let q24 = "24.Do you get worried about your child getting secondary infections?"
    let q25 = "25.Does the thought of relapse trouble you?"
    let q26 = "26.Do you feel anxious about the other kids/ and family members who are left behind in your hometown?"
    this.questionSet.push(q1)
    this.questionSet.push(q2)
    this.questionSet.push(q3)
    this.questionSet.push(q4)
    this.questionSet.push(q5)
    this.questionSet.push(q6)
    this.questionSet.push(q7)
    this.questionSet.push(q8)
    this.questionSet.push(q9)
    this.questionSet.push(q10)
    this.questionSet.push(q11)
    this.questionSet.push(q12)
    this.questionSet.push(q13)
    this.questionSet.push(q14)
    this.questionSet.push(q15)
    this.questionSet.push(q16)
    this.questionSet.push(q17)
    this.questionSet.push(q18)
    this.questionSet.push(q19)
    this.questionSet.push(q20)
    this.questionSet.push(q21)
    this.questionSet.push(q22)
    this.questionSet.push(q23)
    this.questionSet.push(q24)
    this.questionSet.push(q25)
    this.questionSet.push(q26)
    this.addQuestion(q1)
    this.addQuestion(q2)
    this.addQuestion(q3)
    this.addQuestion(q4)
    this.addQuestion(q5)
    this.addQuestion(q6)
    this.addQuestion(q7)
    this.addQuestion(q8)
    this.addQuestion(q9)
    this.addQuestion(q10)
    this.addQuestion(q11)
    this.addQuestion(q12)
    this.addQuestion(q13)
    this.addQuestion(q14)
    this.addQuestion(q15)
    this.addQuestion(q16)
    this.addQuestion(q17)
    this.addQuestion(q18)
    this.addQuestion(q19)
    this.addQuestion(q20)
    this.addQuestion(q21)
    this.addQuestion(q22)
    this.addQuestion(q23)
    this.addQuestion(q24)
    this.addQuestion(q25)
    this.addQuestion(q26)
  }
  setQuestionsFromData() {
    let arr: any[]
    arr= this.data.assessment

    arr.forEach((r: { q: string;ans:string })=>{
this.questionSet.push(r.q)
  this.addQuestionData(r.q,r.ans)
})
  }

}
function capitalizeSentence(sentence:string) {
  if (!sentence) return ''; // Handle empty input

  const words = sentence.split(' ');
  const capitalizedWords = words.map(word => {
    if (word.length > 0) {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    }
    return word;
  });

  return capitalizedWords.join(' ');
}
